import { useSearchParams } from "react-router-dom";

import { useParsedQueryParamsWithDefaults } from "@js/hooks";
import { buildSearchParams } from "@js/utils";

import type { RostersFiltersFormValues } from "../../components/rosters-filters/schema";
import { rostersFiltersSchema } from "../../components/rosters-filters/schema";

const defaultFilters = {
  search: null,
  visibility: null,
  page: undefined,
} satisfies RostersFiltersFormValues;

export const useRostersFilters = () => {
  const [, setSearchParams] = useSearchParams();
  const { data: filters } = useParsedQueryParamsWithDefaults(
    rostersFiltersSchema,
    defaultFilters,
  );

  const setFilters = (patch: Partial<RostersFiltersFormValues>) => {
    setSearchParams(buildSearchParams(patch));
  };

  return { filters, setFilters };
};
